import React from "react";
//#region types
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { RecurringInvoiceStatusTagsProps } from "models/propTypes/invoicePropTypes";
//#endregion
//#region components
import { Tags } from "components/common";
import { useRecurringInvoiceService } from "serviceHooks";
//#endregion
import cssExports from "theme/styles/main.module.scss";

const RecurringInvoiceStatusTags: React.FC<RecurringInvoiceStatusTagsProps> = (props) => {
  const recurringInvoiceService = useRecurringInvoiceService();
  const getLabelClass = (status: WintSuperkollAPIModel.RecurringInvoiceState) => {
    switch (status) {
      case WintSuperkollAPIModel.RecurringInvoiceState.Ongoing:
        return cssExports.greenTag;
      default:
        return cssExports.grayTag;
    }
  };

  return <Tags tags={[recurringInvoiceService.getStateText(props.status)]} className={getLabelClass(props.status)} />;
};

export default RecurringInvoiceStatusTags;
